import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
// import loggerMiddleware from './middlewares/loggerMiddleware'
import rootReducer from './reducer'

const middlewares = [thunk]

if (process.env.NODE_ENV !== 'production') {
  // middlewares.push(loggerMiddleware)
}

const configureStore = () => {
  const store = createStore(rootReducer, applyMiddleware(...middlewares))
  return store
}

export default configureStore
